import { render, staticRenderFns } from "./SensorCertificateBadge.vue?vue&type=template&id=af25bc4e&scoped=true&"
import script from "./SensorCertificateBadge.vue?vue&type=script&lang=ts&"
export * from "./SensorCertificateBadge.vue?vue&type=script&lang=ts&"
import style0 from "./SensorCertificateBadge.vue?vue&type=style&index=0&id=af25bc4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af25bc4e",
  null
  
)

export default component.exports